import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { closeModal, setModal } from "../../features/modal/ModalSlice";
import { Modal } from "react-bootstrap";
import Signup from "../Auth/Signup";
import OTPVerification from "../Auth/OTPVerification";
import { IoCloseOutline } from "react-icons/io5";

const SignupPopUp = () => {
  const dispatch = useDispatch();
  const [currentScreen, setCurrentScreen] = useState("signup");
  const [email, setEmail] = useState("");

  const handleClosePopup = () => {
    dispatch(closeModal());
  };

  // Function to switch to the OTP screen
  const handleSignupSubmit = ({ email }) => {
    setEmail(email);
    setCurrentScreen("otp");
  };

  // Function to close the popup after OTP submission
  const handleOTPSubmit = ({ company_owner }) => {
    handleClosePopup();
    const data = {
      company_owner,
    };
    dispatch(setModal({ type: "CREATE_COMPANY", data }));
  };

  return (
    <div>
      <Modal
        show={true}
        onHide={handleClosePopup}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="taskModal"
      >
        <Modal.Header className="px-4 py-3">
          <h4 className="m-0">Create Account</h4>
          <button className="btnClose ms-auto" onClick={handleClosePopup}>
            <IoCloseOutline />
          </button>
        </Modal.Header>
        <Modal.Body className="px-5">
          {currentScreen === "signup" ? (
            <Signup onSubmit={handleSignupSubmit} />
          ) : (
            <OTPVerification handleOTPSubmit={handleOTPSubmit} email={email} />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SignupPopUp;
